package com.patronat.top.ui.molecules.header

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.painter.Painter
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.dp
import com.patronat.top.ui.theme.LabelLarge
import com.patronat.top.ui.theme.MineShaft500
import com.patronat.top.ui.theme.MineShaft900
import com.patronat.top.ui.theme.Primary100
import com.patronat.top.ui.theme.Primary600
import com.patronat.top.ui.theme.White

@Composable
fun SectionCardHeader(
    title: String,
    modifier: Modifier = Modifier,
    leadingIcon: Painter? = null,
    trailingIcon: Painter? = null,
    onTrailingClick: (() -> Unit)? = null,
    titleStyle: TextStyle = LabelLarge,
    titleColor: Color = MineShaft900
) {
    Row(
        modifier = modifier.fillMaxWidth(),
        verticalAlignment = Alignment.CenterVertically
    ) {
        if (leadingIcon != null) {
            Box(
                modifier = Modifier
                    .size(36.dp)
                    .background(Primary100, RoundedCornerShape(8.dp)),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = leadingIcon,
                    contentDescription = null,
                    tint = Primary600,
                    modifier = Modifier.size(18.dp)
                )
            }
        }

        Text(
            text = title,
            style = titleStyle,
            color = titleColor,
            modifier = Modifier.padding(start = if (leadingIcon != null) 10.dp else 0.dp)
        )

        Spacer(modifier = Modifier.weight(1f))

        if (trailingIcon != null) {
            val trailingModifier = if (onTrailingClick != null) {
                Modifier.clickable { onTrailingClick() }
            } else {
                Modifier
            }

            Box(
                modifier = trailingModifier
                    .size(26.dp)
                    .background(White, CircleShape),
                contentAlignment = Alignment.Center
            ) {
                Icon(
                    painter = trailingIcon,
                    contentDescription = null,
                    tint = MineShaft500,
                    modifier = Modifier.size(14.dp)
                )
            }
        }
    }
}
